import useAuthContext from 'contexts/AuthContext';
import React, { useEffect, useState } from 'react';
import RenderIf from '../../../../components/RenderIf/RenderIf';
import { useDealsOverview } from '../../context/DealsOverviewProvider';
import { mapSubprojectStagesToCounts } from '../../helpers/subprojectStages';
import { useGetSubprojectsStages } from '../../hooks/useGetSubprojectStages';
import { useGetSubprojectsStagesCount } from '../../hooks/useGetSubprojectStagesCount';
import './ProjectStages.scss';

interface IStage {
    id: string;
    name: string;
    subprojects_count: number;
}

const ProjectStages = () => {
    const {
        handleClickStage, projectCountsByStageId, setProjectCountsByStageId, selectedStages,
    } = useDealsOverview();
    const { selectedOrganizationId } = useAuthContext();
    const { data: subprojectStages } = useGetSubprojectsStages();
    const { data: subprojectStagesCount } = useGetSubprojectsStagesCount({
        orgId: selectedOrganizationId!,
        shouldFetch: !!subprojectStages,
    });

    const [data, setData] = useState<IStage[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (subprojectStages && subprojectStagesCount) {
            const mappedStages = mapSubprojectStagesToCounts(subprojectStages, subprojectStagesCount);
            setData(mappedStages);
            setIsLoading(false);
        }
    }, [subprojectStages, subprojectStagesCount]);

    useEffect(() => {
        if (data.length > 0) {
            const counts: Record<string, number> = {};
            data.forEach(stage => {
                counts[stage.id] = stage.subprojects_count;
            });
            setProjectCountsByStageId(counts);
        }
    }, [data, setProjectCountsByStageId]);

    const getHeapClassName = (stageName: string): string => {
        const stageClassMap: Record<string, string> = {
            Opportunity: 'heap-deal-pipeline-opportunity',
            'Due Diligence': 'heap-deal-pipeline-due-diligence',
            'Pre-Development': 'heap-deal-pipeline-predevelopment',
            Construction: 'heap-deal-pipeline-construction',
            Stabilization: 'heap-deal-pipeline-stabilization',
            Completed: 'heap-deal-pipeline-completed',
            Archived: 'heap-deal-pipeline-archived',
        };

        return stageClassMap[stageName] || '';
    };

    return (
        <RenderIf isTrue={!isLoading} isLoading={isLoading}>
            <div className="ProjectStages position-relative mt-3">
                {data.map(stage => (
                    <div
                        className={`ProjectStages__steps cursor--pointer d-flex align-items-center position-relative ${getHeapClassName(stage.name)}`}
                        key={stage.id}
                        onClick={() => handleClickStage(stage.id)}
                        role="presentation"
                    >
                        <div className={`ProjectStages__steps__circle ${selectedStages?.[stage.id] ? 'active' : ''}`}>
                            {projectCountsByStageId?.[stage.id] || 0}
                        </div>
                        <div className="ProjectStages__steps__stage">
                            {selectedStages?.[stage.id] ? <span className="ProjectStages__steps__stage__name">{stage.name}</span> : stage.name}
                        </div>
                    </div>
                ))}
            </div>
        </RenderIf>
    );
};

export default ProjectStages;
